import { Stack, Tooltip, Typography } from "@mui/material";
import UserAvatar from "@entrilia/shared/components/UserAvatar";

interface RecipientProps {
  recipientName: string;
  email: string;
}

export const RecipientCell = ({ recipientName, email }: RecipientProps) => (
  <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", width: "100%" }}>
    <UserAvatar size="medium" userName={recipientName} />
    <Stack spacing={0.5} sx={{ width: "calc(100% - 32px)" }}>
      <Typography variant="subtitle2" noWrap>
        {recipientName}
      </Typography>
      <Tooltip title={email}>
        <Typography variant="caption" noWrap>
          {email}
        </Typography>
      </Tooltip>
    </Stack>
  </Stack>
);
